import { atomFamily, selectorFamily, waitForNone } from 'recoil';
import type { BlockId } from '../types';
import { unsavedChangesEffect } from '../../effects/unsavedChangesEffect';
import { viewInputManagementVersion } from './input-management/rolloutUtils';

const isLinkedState = atomFamily<boolean, BlockId>({
  key: 'isLinkedState',
  default: true,
  effects: [unsavedChangesEffect],
});

/**
 * Wrapper selector around {@link isLinked} that short-circuits when input management V2 is enabled (in which global linking no longer exists).
 *
 * When V2 input management is enabled, returns false on get and throws an error on set.
 * TODO: post-migration, this should be deleted.
 */
export const isLinked = selectorFamily<boolean, BlockId>({
  key: 'isLinkedSelector',
  get:
    (id) =>
    ({ get }) => {
      if (get(viewInputManagementVersion) === 2) {
        return false;
      }
      return get(isLinkedState(id));
    },
  set:
    (id) =>
    ({ get, set }, newValue) => {
      const [inputManagementVersion] = get(waitForNone([viewInputManagementVersion]));
      if (inputManagementVersion.valueMaybe() === 2) {
        throw new Error('should not be possible to set isLinked when using V2 input management');
      }
      return set(isLinkedState(id), newValue);
    },
});
